<template>
  <p>
    {{ $t("ResultsIndicatorShowing") }}
    <strong>{{ first }} - {{ last }}</strong> {{ $t("ResultsIndicatorOf") }}
    <strong>{{ total }} </strong>{{ indexTitle }}<span v-if="total > 1">s</span>
    <span v-if="term.length > 0"> {{ $t("ResultsIndicatorFor") }} </span>
    <strong v-if="term.length > 0">{{ term }}</strong>
  </p>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ResultsIndicator",
  props: {
    first: {
      type: Number,
      required: true,
      default: 0
    },
    last: {
      type: Number,
      required: true,
      default: 0
    },
    total: {
      type: Number,
      required: true,
      default: 0
    },
    term: {
      type: String,
      required: true,
      default: ""
    },
    indexTitle: {
      type: String,
      required: true,
      default: ""
    }
  }
});
</script>
